import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import BodycamOnboardingPanel from "../../shared/components/BodycamOnboardingPanel";
import { useKardaAdmin } from "./KardaAdminContext";

const StationBodycamSection: React.FC = () => {
  const { stationId } = useParams<{ stationId: string }>();
  const { fetchBodycamIntegration, setBodycamIntegration, getBodycamIntegration } = useKardaAdmin();

  useEffect(() => {
    if (stationId) fetchBodycamIntegration(stationId);
  }, [stationId, fetchBodycamIntegration]);

  const { vendor, isLoading, isFetched } = getBodycamIntegration(stationId!);

  return (
    <>
      <Typography variant="h6" fontWeight="bold" marginBottom={1}>
        Edit Station Bodycam Integration
      </Typography>
      {isLoading && !isFetched ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      ) : (
        <BodycamOnboardingPanel
          stationId={stationId!}
          initialVendorAlreadyOnboarded={isFetched ? vendor : undefined}
          onVendorChange={(v) => setBodycamIntegration(stationId!, v)}
        />
      )}
    </>
  );
};

export default StationBodycamSection;
